<template>
  <v-select
          label="Typ přístupu"
          color="light-green darken-1"
          variant="underlined"
          class="col-3 sm6"
          :value="value"
          :items='accessTypes'
  ></v-select>
</template>


<script>
    export default {
        name: 'AccessSelect',

        props: {
            value: String,
        },

        data() {
          return {
            accessTypes: [
              {title: 'Neomezený přístup', value: '0'},
              {title: 'Přístup pouze s odpovědnou osobou', value: '1'},
              {title: 'Přístup pouze s kartou', value: '2'},
            ],
          }
        },
    }
</script>

<style scoped>
</style>
